import React from 'react';
import { IProps } from './types';
import commonService from 'utils/commonService';
import { CodeId } from 'constants/enums/codeId.enum';

const Compare: React.FC<IProps> = (props) => (
  <div className="compare">
    <div className="template-container">
      <div className="template-content vs-area">
        <div className="compare__title-section">
          <div className="compare__title">{commonService.getCodeMsg(props.ePolicyCodes, CodeId.VSTITLE)}</div>
        </div>
        <div className="compare__table">
          <table className="element__table-horizon">
            <tbody>
              <tr>
                <th className="element__table-horizon-x-title">{commonService.getCodeMsg(props.ePolicyCodes, CodeId.VS_T_00)}</th>
                <th className="element__table-horizon-x-title">{commonService.getCodeMsg(props.ePolicyCodes, CodeId.VS_E_00)}</th>
              </tr>
              <tr>
                <th className="element__table-horizon-y-title">{commonService.getCodeMsg(props.ePolicyCodes, CodeId.VS_T_01)}</th>
                <td>{commonService.getCodeMsg(props.ePolicyCodes, CodeId.VS_E_01)}</td>
              </tr>
              <tr>
                <th className="element__table-horizon-y-title">{commonService.getCodeMsg(props.ePolicyCodes, CodeId.VS_T_02)}</th>
                <td>{commonService.getCodeMsg(props.ePolicyCodes, CodeId.VS_E_02)}</td>
              </tr>
              <tr>
                <th className="element__table-horizon-y-title">{commonService.getCodeMsg(props.ePolicyCodes, CodeId.VS_T_03)}</th>
                <td>{commonService.getCodeMsg(props.ePolicyCodes, CodeId.VS_E_03)}</td>
              </tr>
              <tr>
                <th className="element__table-horizon-y-title">{commonService.getCodeMsg(props.ePolicyCodes, CodeId.VS_T_04)}</th>
                <td>{commonService.getCodeMsg(props.ePolicyCodes, CodeId.VS_E_04)}</td>
              </tr>
              <tr>
                <th className="element__table-horizon-y-title">{commonService.getCodeMsg(props.ePolicyCodes, CodeId.VS_T_05)}</th>
                <td>{commonService.getCodeMsg(props.ePolicyCodes, CodeId.VS_E_05)}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
);

export default Compare;
